import type { TFunction } from 'i18next'

export type FbcSignalState = 'idle' | 'active' | 'signal'

export type FbcChannelId =
  | 'matrix'
  | 'voice'
  | 'vision'
  | 'screen'
  | 'memory'
  | 'research'
  | 'export'
  | 'report'
  | 'halt'
  | 'transmit'
  | 'phase'
  | 'signal'

export interface FbcChannelDef {
  id: FbcChannelId
  label: string
  statusLabel: string
}

export const FBC_GRAMMAR = {
  dotSize: 4,
  dotGap: 3,
  signalTracking: '0.18em',
  labelTracking: '0.2em',
  labelSize: '9px',
  microLabelSize: '8px',
} as const

export const FBC_CHANNELS: Record<FbcChannelId, FbcChannelDef> = {
  matrix: { id: 'matrix', label: 'Matrix', statusLabel: 'MATRIX' },
  voice: { id: 'voice', label: 'Voice', statusLabel: 'VOICE' },
  vision: { id: 'vision', label: 'Video', statusLabel: 'VIDEO' },
  screen: { id: 'screen', label: 'Screen', statusLabel: 'SCREEN' },
  memory: { id: 'memory', label: 'Memory', statusLabel: 'MEMORY' },
  research: { id: 'research', label: 'Research', statusLabel: 'RESEARCH' },
  export: { id: 'export', label: 'Export', statusLabel: 'EXPORT' },
  report: { id: 'report', label: 'Report', statusLabel: 'REPORT' },
  halt: { id: 'halt', label: 'Halt', statusLabel: 'HALT SIGNAL' },
  transmit: { id: 'transmit', label: 'Transmit', statusLabel: 'TRANSMIT' },
  phase: { id: 'phase', label: 'Phase', statusLabel: 'PHASE SHIFT' },
  signal: { id: 'signal', label: 'Signal', statusLabel: 'SIGNAL' },
}

export const FBC_PRESENCE_CHANNELS: FbcChannelId[] = ['voice', 'vision', 'screen', 'memory']

export const FBC_CONSOLE_CHANNELS: FbcChannelId[] = [
  'matrix',
  'voice',
  'vision',
  'screen',
  'memory',
  'research',
]

export function fbcChannelState(active: boolean): FbcSignalState {
  return active ? 'signal' : 'idle'
}

export function getFbcChannelLabel(
  channel: FbcChannelId,
  t: TFunction,
  field: 'label' | 'status' = 'label'
): string {
  const suffix = field === 'status' ? 'status' : 'label'
  return t(`channel.${channel}.${suffix}`)
}
